import { usePostApply } from '@components/hooks/PostApplyProvider/index.client'
import Button, { buttonClassNames } from '@components/primitives/Button'
import { IconSuffix } from '@components/primitives/Icon/IconSuffix'
import { classMerge } from '@components/utilities/classMerge'
import { faArrowRight } from '@fortawesome/pro-regular-svg-icons/faArrowRight'
import { faSpinnerThird } from '@fortawesome/pro-regular-svg-icons/faSpinnerThird'
import type { ApplySuccessPageProps } from 'app/p/apply-success/[token]/[step]/page'
import { useRouter } from 'next/navigation'
import { getApplySuccessRouteToRedirectTo } from './getApplySuccessRouteToRedirectTo'

export default function SaveStudyTeamContactButtonGroup(
  props: ApplySuccessPageProps,
) {
  const { advanceToNextStep, isLoading } = usePostApply()

  const router = useRouter()

  const icon = isLoading ? faSpinnerThird : faArrowRight
  const animateClassName = isLoading
    ? 'motion-safe:animate-spin'
    : 'motion-safe:animate-none'
  return (
    <div className='z-10 mx-8 flex w-full flex-row justify-end gap-2'>
      <Button
        className={classMerge(
          buttonClassNames.primary.black,
          'pointer-events-auto w-full rounded-full md:w-48',
        )}
        disabled={isLoading}
        onClick={async () => {
          advanceToNextStep()
          router.push(
            getApplySuccessRouteToRedirectTo('save-study-team-contact', {
              allowPatientCallToSite: props.allowPatientCallToSite,
              canPatientContactSite: props.canPatientContactSite,
              consentForEmr: props.consentForEmr,
              consentToShareYourStory: props.consentToShareYourStory,
              hasPatientNavigatorAgentCallCompleted:
                props.hasPatientNavigatorAgentCallCompleted,
              idToken: props.idToken,
              isFullyQualified: props.isFullyQualified,
              isQualifiedApply: props.isQualifiedApply,
              showScreeningVisitQualificationStep:
                props.showScreeningVisitQualificationStep,
              whyAreYouApplying: props.whyAreYouApplying,
            }),
          )
        }}
        value={
          <IconSuffix className={animateClassName} icon={icon}>
            <span className='mr-2'>Next</span>
          </IconSuffix>
        }
      />
    </div>
  )
}
